import Image from "next/image";

// import {
//   Carousel,
//   CarouselContent,
//   CarouselItem,
//   CarouselNext,
//   CarouselPrevious,
// } from "@/components/ui/carousel";

import { type FragmentOf, type SiteLocale, readFragment } from "~/lib/graphql";

import * as fragment from "./graphql";

export function SpeakerBlock(props: {
  record: FragmentOf<typeof fragment.SpeakerblockFragment>;
  locale: SiteLocale;
}) {
  const record = readFragment(fragment.SpeakerblockFragment, props.record);

  const speakers = record.speaker;

  return (
    <section className="max-w-full overflow-hidden px-4 py-10">
      {/* <h3 className="container mx-auto w-full py-10 text-white/80 uppercase lg:px-0">
        Authors
      </h3> */}

      <div className="container mx-auto w-full text-[14px]">
        <div className="flex flex-col flex-wrap items-center justify-center gap-4 sm:flex-row md:gap-6 lg:gap-8">
          {speakers.map((speaker) => (
            <div
              className="group border-border flex w-full flex-col items-center rounded-[8px] border bg-white p-4 text-center transition-colors md:max-w-[31%]"
              key={speaker.id}
            >
              {speaker?.employee ? (
                <>
                  {speaker.employee.profilePicture && (
                    <div className="mb-4 h-[100px] w-[100px] overflow-hidden rounded-full transition-colors">
                      <Image
                        src={`${speaker.employee.profilePicture?.url}?w=100&h=100&fit=crop&crop=focalpoint&fp-x=${speaker.employee.profilePicture?.focalPoint?.x}&fp-y=${speaker.employee.profilePicture?.focalPoint?.y}&auto=format&dpr=3`}
                        alt={speaker.name || ""}
                        width={100}
                        height={100}
                        className="h-full w-full rounded-full object-cover"
                      />
                    </div>
                  )}
                  <h3 className="mb-1">
                    {speaker.employee.firstName} {speaker.employee.lastName}
                  </h3>
                  {speaker.employee.orcid && (
                    <a
                      href={`https://orcid.org/${speaker.employee.orcid}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center text-[8px] group-hover:opacity-100 hover:underline md:text-[14px] md:opacity-0"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 256 256"
                        className="mr-1 inline-block h-[10px] w-[10px] md:h-[14px] md:w-[14px]"
                      >
                        <path
                          fill="#A6CE39"
                          d="M256 128c0 70.7-57.3 128-128 128S0 198.7 0 128 57.3 0 128 0s128 57.3 128 128z"
                        ></path>
                        <path
                          fill="#FFF"
                          d="M86.3 186.2H70.9V79.1h15.4v107.1zm22.6-107.1h41.6c39.6 0 57 28.3 57 53.6 0 27.5-21.5 53.6-56.8 53.6h-41.8V79.1zm15.4 93.3h24.5c34.9 0 42.9-26.5 42.9-39.7C191.7 111.2 178 93 148 93h-23.7v79.4zM88.7 56.8c0 5.5-4.5 10.1-10.1 10.1s-10.1-4.6-10.1-10.1c0-5.6 4.5-10.1 10.1-10.1s10.1 4.6 10.1 10.1z"
                        ></path>
                      </svg>{" "}
                      {speaker.employee.orcid}
                    </a>
                  )}

                  {speaker.subtitle && <p className="">{speaker.subtitle}</p>}
                </>
              ) : (
                <>
                  {speaker.image ? (
                    <div className="mb-4 h-[100px] w-[100px] overflow-hidden rounded-full transition-colors">
                      <Image
                        src={`${speaker.image?.url}?w=100&h=100&fit=crop&crop=focalpoint&fp-x=${speaker.image?.focalPoint?.x}&fp-y=${speaker.image?.focalPoint?.y}&auto=format&dpr=3`}
                        alt={speaker.name || ""}
                        width={100}
                        height={100}
                        className="h-full w-full object-cover"
                      />
                    </div>
                  ) : (
                    <div className="mb-4 h-[100px] w-[100px] overflow-hidden bg-white/5"></div>
                  )}
                  <h3 className="mb-1">{speaker.name}</h3>
                  {speaker.subtitle && <p className="">{speaker.subtitle}</p>}
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
